import CallCenterForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallCenterForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('callCenters.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.callCenters.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.callCenters.index'), route: {name: 'call-centers-index'}},
          {label: this.$t('breadcrumbs.callCenters.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateCallCenter(data) {
      API.callCenters.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('callCenters.edit.succesfullyUpdated'))
        this.$router.push({name: 'call-centers-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
